import { observer } from 'mobx-react';
import * as React from 'react';
import { L, T } from '../../../Translations';
import { distanceOfTimeInWords } from '../../../Time';
import { Maybe } from 'maybeasy';

interface Props {
  lastLoginAt: Maybe<Date>;
}

const LastLoginAt: React.FC<Props> = ({ lastLoginAt }) =>
  lastLoginAt
    .map((date) => (
      <>
        <span className="mr-1">
          <L localizeable={date} format="short-month-day-year" />
        </span>
        <span className="mr-1">
          <L localizeable={date} format="time-of-day" />
        </span>
        <div className="text-sm">
          {'('}
          <T {...distanceOfTimeInWords(new Date(), date)} />
          {')'}
        </div>
      </>
    ))
    .getOrElse(() => <>--</>);

export default observer(LastLoginAt);
